import React from 'react'
import { FormikState } from 'formik'

import { useCategories } from '@hooks/useCategories'
import { OrderedEnum } from '@interfaces/OrderedEnum'
import {
  AdvanceSearchFormProps,
  SearchAllFormType,
  WithAdvanceSearchFormProps,
} from './interface'

const defaultInitialValues: SearchAllFormType = {
  bookType: [],
  categoryIds: [],
  searchText: '',
  secondaryType: undefined,
  orderBy: OrderedEnum.NEW_OLD,
}

export function withAdvanceSearchForm(
  Component: React.FC<AdvanceSearchFormProps>
) {
  function WithAdvanceSearchForm({
    initialValues,
    handleSubmit,
    ...props
  }: WithAdvanceSearchFormProps) {
    const { categories } = useCategories()

    function handleReset(
      resetForm: (nextState?: Partial<FormikState<SearchAllFormType>>) => void
    ) {
      const values = defaultInitialValues
      resetForm({ values })
      handleSubmit(values)
    }

    const newProps = {
      ...props,
      initialValues,
      categories,
      handleSubmit,
      handleReset,
    }
    return <Component {...newProps} />
  }

  return WithAdvanceSearchForm
}
